var _defs, _g, _rect, _rect2, _path, _circle, _circle2, _circle3, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _circle4, _path2, _path3, _path4, _rect13, _rect14, _circle5, _path5, _path6, _rect15, _rect16, _path7, _path8, _path9, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAiBackgroundEl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_10",
    "data-name": "Layer 10",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 642.63 544.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0b9c9;}.cls-2{fill:#f8dde1;}.cls-3{fill:#ed718b;}.cls-4{fill:#feefeb;}.cls-5{fill:#1f1a39;}.cls-6{fill:#ea656e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ai_backgroundEl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13",
    "data-name": "Layer 13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.35,
    y: 6.29,
    width: 546.28,
    height: 537.92,
    rx: 16.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.15,
    width: 546.28,
    height: 537.92,
    rx: 16.81
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2.91,
    y: 296.86,
    width: 162.97,
    height: 116.63,
    rx: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 294.12,
    width: 162.97,
    height: 116.63,
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104.92,0h513a16.54,16.54,0,0,1,16.54,16.54V63a6.35,6.35,0,0,1-6.35,6.35H92a4.77,4.77,0,0,1-4.77-4.77V17.65A17.65,17.65,0,0,1,104.92,0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 200.82,
    cy: 37.05,
    r: 11.93
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 166.46,
    cy: 37.05,
    r: 11.93
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 132.41,
    cy: 37.05,
    r: 11.93
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 122.08,
    y: 99.56,
    width: 229.27,
    height: 11.35,
    rx: 5.68
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 149.05,
    y: 120.31,
    width: 74.7,
    height: 11.35,
    rx: 5.68
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 122.08,
    y: 205.2,
    width: 229.27,
    height: 11.35,
    rx: 5.68
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 149.05,
    y: 225.96,
    width: 74.7,
    height: 11.35,
    rx: 5.68
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 149.05,
    y: 137.44,
    width: 179.32,
    height: 11.35,
    rx: 5.68
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.65,
    y: 160.41,
    width: 103.88,
    height: 11.35,
    rx: 5.68
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 148.88,
    y: 244.48,
    width: 153.59,
    height: 11.35,
    rx: 5.68
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 149.69,
    y: 181,
    width: 219.8,
    height: 11.35,
    rx: 5.68
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 122.08,
    y: 160.41,
    width: 74.7,
    height: 11.35,
    rx: 5.68
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 234.05,
    y: 225.96,
    width: 74.7,
    height: 11.35,
    rx: 5.68
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.68,
    cy: 307.4,
    r: 2.99
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M317.11,529.76v6.1l-24.48-10.37v-4l24.48-10.32v6.09l-15.41,6Z",
    transform: "translate(-260.05 -172.01)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M347.3,502.45l-20.16,40.8H321l20.35-40.8Z",
    transform: "translate(-260.05 -172.01)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M351.14,517.23v-6.09l24.48,10.32v4l-24.48,10.37v-6.1l15.41-6.1Z",
    transform: "translate(-260.05 -172.01)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 153.59,
    y: 357.98,
    width: 144.17,
    height: 95.97,
    rx: 12
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 151.66,
    y: 353.8,
    width: 144.17,
    height: 95.97,
    rx: 12
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 162.9,
    cy: 364.5,
    r: 2.99
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M462.37,594.4a5.08,5.08,0,0,0,2.16.46,3.27,3.27,0,0,0,2.14-.91,4,4,0,0,0,1-3.12V556h7.2v36.29a9.07,9.07,0,0,1-.75,3.86,6.84,6.84,0,0,1-2.11,2.64,9,9,0,0,1-3.17,1.51,15,15,0,0,1-3.86.48,12,12,0,0,1-3.24-.43,17.37,17.37,0,0,1-2.79-1,11.68,11.68,0,0,1-2-1.15l3.7-4.94A5.16,5.16,0,0,0,462.37,594.4Z",
    transform: "translate(-260.05 -172.01)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M487.45,581.56a9.54,9.54,0,0,0,2.81,2.16,7.17,7.17,0,0,0,3.31.77,5.19,5.19,0,0,0,3.36-1,3.55,3.55,0,0,0,1.29-2.89,3.86,3.86,0,0,0-.79-2.54,6.7,6.7,0,0,0-2.35-1.7c-1-.5-2.31-1-3.82-1.61-.8-.29-1.72-.68-2.76-1.18a13.32,13.32,0,0,1-2.95-1.92,9.63,9.63,0,0,1-2.3-2.88,8.53,8.53,0,0,1-.91-4.1,8.4,8.4,0,0,1,1.46-5,9.47,9.47,0,0,1,4-3.21,13.53,13.53,0,0,1,5.64-1.13,13.08,13.08,0,0,1,5.55,1.08,12.56,12.56,0,0,1,3.89,2.73,14.17,14.17,0,0,1,2.42,3.43l-5.38,3a10.47,10.47,0,0,0-1.6-2.18,7.7,7.7,0,0,0-2.14-1.59,6,6,0,0,0-2.74-.6,4.32,4.32,0,0,0-3,.94,2.89,2.89,0,0,0-1,2.18,3.21,3.21,0,0,0,.82,2.19,8.06,8.06,0,0,0,2.49,1.77,34.66,34.66,0,0,0,4.23,1.71,18.53,18.53,0,0,1,3.14,1.44,12.67,12.67,0,0,1,2.74,2.09,9,9,0,0,1,1.92,2.88,9.81,9.81,0,0,1,.69,3.81,9.65,9.65,0,0,1-1,4.37,9.44,9.44,0,0,1-2.64,3.24,12.27,12.27,0,0,1-3.76,2,13.7,13.7,0,0,1-4.4.7,14.08,14.08,0,0,1-5.73-1.17,14.64,14.64,0,0,1-4.63-3.2,15.81,15.81,0,0,1-3.08-4.37l4.9-3.45A17.09,17.09,0,0,0,487.45,581.56Z",
    transform: "translate(-260.05 -172.01)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 79.38,
    y: 436.65,
    width: 132.43,
    height: 90.5,
    rx: 15.76
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 76.88,
    y: 432.91,
    width: 132.43,
    height: 90.5,
    rx: 12.31
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M366.15,656.72a10.26,10.26,0,0,0,4,3.79,11.08,11.08,0,0,0,5.33,1.32,13.73,13.73,0,0,0,4.28-.62,13.51,13.51,0,0,0,3.38-1.68,15.18,15.18,0,0,0,2.62-2.31V665a16.54,16.54,0,0,1-4.49,2.54,17.53,17.53,0,0,1-6.12.92,20,20,0,0,1-7.13-1.25,16.36,16.36,0,0,1-9.46-9.15,19.65,19.65,0,0,1,0-14.16,16.38,16.38,0,0,1,9.46-9.14,20,20,0,0,1,7.13-1.25,17.79,17.79,0,0,1,6.12.91,16.84,16.84,0,0,1,4.49,2.55v7.73a14.77,14.77,0,0,0-2.62-2.31,13.51,13.51,0,0,0-3.38-1.68,13.73,13.73,0,0,0-4.28-.62,11.08,11.08,0,0,0-5.33,1.32,10.32,10.32,0,0,0-4,3.76,11.83,11.83,0,0,0,0,11.6Z",
    transform: "translate(-260.05 -172.01)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M397.78,659.72a9.5,9.5,0,0,0,2.8,2.16,7.36,7.36,0,0,0,3.32.77,5.2,5.2,0,0,0,3.36-1.06,3.51,3.51,0,0,0,1.29-2.88,3.84,3.84,0,0,0-.79-2.54,6.84,6.84,0,0,0-2.35-1.71c-1-.49-2.31-1-3.82-1.61a29.9,29.9,0,0,1-2.76-1.17,14.07,14.07,0,0,1-2.95-1.92,9.72,9.72,0,0,1-2.3-2.88,8.6,8.6,0,0,1-.91-4.11,8.37,8.37,0,0,1,1.46-5,9.35,9.35,0,0,1,4-3.22,13.69,13.69,0,0,1,5.64-1.13,13.11,13.11,0,0,1,5.55,1.08,12.42,12.42,0,0,1,3.89,2.74,14.25,14.25,0,0,1,2.42,3.43l-5.38,3a10.85,10.85,0,0,0-1.61-2.19,7.67,7.67,0,0,0-2.13-1.58,6,6,0,0,0-2.74-.6,4.32,4.32,0,0,0-3,.93,2.93,2.93,0,0,0-1,2.19,3.18,3.18,0,0,0,.82,2.18A7.91,7.91,0,0,0,403,646.4a33.24,33.24,0,0,0,4.23,1.7,20.67,20.67,0,0,1,3.14,1.44,13,13,0,0,1,2.74,2.09,9.19,9.19,0,0,1,1.92,2.88,9.86,9.86,0,0,1,.69,3.82,9.61,9.61,0,0,1-1,4.36,9.44,9.44,0,0,1-2.64,3.24,12.29,12.29,0,0,1-3.76,2,14.36,14.36,0,0,1-10.13-.48,14.77,14.77,0,0,1-4.64-3.19,16.14,16.14,0,0,1-3.07-4.37l4.9-3.46A17.5,17.5,0,0,0,397.78,659.72Z",
    transform: "translate(-260.05 -172.01)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M426.62,659.72a9.67,9.67,0,0,0,2.81,2.16,7.35,7.35,0,0,0,3.31.77,5.16,5.16,0,0,0,3.36-1.06,3.49,3.49,0,0,0,1.3-2.88,3.84,3.84,0,0,0-.79-2.54,6.84,6.84,0,0,0-2.35-1.71c-1-.49-2.32-1-3.82-1.61a29.9,29.9,0,0,1-2.76-1.17,14.07,14.07,0,0,1-2.95-1.92,9.91,9.91,0,0,1-2.31-2.88,8.72,8.72,0,0,1-.91-4.11,8.38,8.38,0,0,1,1.47-5,9.35,9.35,0,0,1,4-3.22,13.69,13.69,0,0,1,5.64-1.13,13.07,13.07,0,0,1,5.54,1.08,12.31,12.31,0,0,1,3.89,2.74,14,14,0,0,1,2.43,3.43l-5.38,3a10.85,10.85,0,0,0-1.61-2.19,7.67,7.67,0,0,0-2.13-1.58,6.07,6.07,0,0,0-2.74-.6,4.32,4.32,0,0,0-3,.93,2.89,2.89,0,0,0-1,2.19,3.22,3.22,0,0,0,.81,2.18,8.09,8.09,0,0,0,2.5,1.78,33.65,33.65,0,0,0,4.22,1.7,20.34,20.34,0,0,1,3.15,1.44,12.68,12.68,0,0,1,2.73,2.09,8.86,8.86,0,0,1,1.92,2.88,10.56,10.56,0,0,1-.26,8.18,9.44,9.44,0,0,1-2.64,3.24,12.34,12.34,0,0,1-3.77,2,13.87,13.87,0,0,1-4.39.7,14.14,14.14,0,0,1-5.74-1.18,14.73,14.73,0,0,1-4.63-3.19,16.14,16.14,0,0,1-3.07-4.37l4.9-3.46A17.94,17.94,0,0,0,426.62,659.72Z",
    transform: "translate(-260.05 -172.01)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 88.94,
    cy: 443.98,
    r: 2.99
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiBackgroundEl);
export default __webpack_public_path__ + "static/media/ai_backgroundEl.0ed29ae0a47518a7c8fa0608cbed3c76.svg";
export { ForwardRef as ReactComponent };